import _uniqueId from "lodash/uniqueId";
import { useState } from 'react';
import { useStyles } from '@signavio/ui';
import Label from '../Label';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function withLabel(WrappedComponent) {
  function Labeled({
    label,
    description,
    inline,
    required,
    errors = [],
    ...rest
  }) {
    const styles = useStyles(defaultStyles, {}, {
      '&inline': !!inline,
      '&required': !!required,
      '&error': errors.length > 0
    });
    const [labelId] = useState(() => _uniqueId());
    if (!label) {
      return /*#__PURE__*/_jsx(WrappedComponent, {
        ...rest
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      ...styles,
      children: [/*#__PURE__*/_jsx("div", {
        ...styles('label'),
        children: /*#__PURE__*/_jsx(Label, {
          htmlFor: labelId,
          title: typeof label === 'string' ? label : null,
          description: description,
          inline: inline,
          children: label
        })
      }), /*#__PURE__*/_jsxs("div", {
        ...styles('control'),
        children: [/*#__PURE__*/_jsx(WrappedComponent, {
          ...rest,
          "aria-invalid": errors.length > 0 ? 'true' : 'false',
          id: labelId
        }), errors.length > 0 && /*#__PURE__*/_jsx("ul", {
          ...styles('errors'),
          children: errors.map(error => /*#__PURE__*/_jsx("li", {
            children: error
          }, error))
        })]
      })]
    });
  }
  return Labeled;
}
const defaultStyles = ({
  spacing,
  color,
  font
}) => ({
  display: 'flex',
  control: {
    width: '60%'
  },
  label: {
    display: 'flex',
    justifyContent: 'flex-end',
    textAlign: 'right',
    paddingRight: spacing.small,
    width: '40%'
  },
  errors: {
    color: color.danger.base,
    fontSize: font.body.fontSize,
    marginTop: spacing.xxsmall,
    marginBottom: 0,
    marginLeft: spacing.small,
    marginRight: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0
  },
  '&required': {
    label: {
      fontWeight: 'bold'
    }
  },
  '&inline': {
    flexDirection: 'column',
    control: {
      width: null
    },
    label: {
      width: null,
      justifyContent: 'flex-start',
      textAlign: 'left',
      marginBottom: spacing.xxsmall
    }
  },
  '&error': {
    label: {
      color: color.status.danger
    }
  }
});
export default withLabel;